function ActiveEventsListController(
  EventsService,
  userService,
  eventsExportService,
  CommonService,
  CarService,
  userViewService,
  arraySortService,
  $uibModal,
  $interval,
  $timeout,
  $translate,
  __env,
  $scope
) {
  const ctrl = this;
  const env = __env;

  ctrl.$onInit = () => {
    ctrl.selectedTrain = CommonService.getSelectedTrain();
    ctrl.selectedCar = CommonService.getSelectedCar();
    ctrl.currentView = userViewService.getView();
    ctrl.consist = CommonService.getConsist();
    ctrl.contentAreaId = 'div#activeScrollContainer';
    ctrl.area = '#gridletContentArea-active-events-list-gridlet';
    ctrl.sortType = 'ACTIVATED';
    ctrl.sortReverse = true;
    ctrl.dataLoading = false;
    ctrl.smallFont = false;
    ctrl.loadBusy = false;
    ctrl.events = [];
    ctrl.accordionStatus = null;
    ctrl.customMelco = env.profile === 'MELCO';
    ctrl.hasConsist = env.profile !== 'QR' && env.profile !== 'VALE' && env.profile !== 'MELCO';
    ctrl.hasActiveEventRead = userService.hasActiveEventRead();
    $scope.$emit('gridlet-register-export', {
      excel: () => ctrl.exportTo('excel'),
      csv: () => ctrl.exportTo('csv'),
      isExporting: () => ctrl.fetching,
    });
    if (ctrl.hasActiveEventRead) {
      ctrl.loadEvents();
      startPoll();
    }
    ctrl.initialized = true;
  };

  ctrl.$onChanges = changes => {
    if (changes.settings && ctrl.initialized) {
      $timeout(() => {
        adjustContentSize(ctrl.area, ctrl.contentAreaId);
        ctrl.loadEventsPage();
      }, 200);
    }
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.dataFetchPromise);
  };

  const adjustContentSize = (selectorId, contentAreaSelectorId) => {
    $timeout(function () {
      ctrl.areaWidth = $(contentAreaSelectorId).width();
      // If adjust is fired when resize event is going on, size is incorrectly set to 100
      if (ctrl.areaWidth === 100) {
        ctrl.smallFont = false;
      } else {
        ctrl.smallFont = ctrl.areaWidth < 580;
      }
    }, 200);
  };

  // Triggered with 500ms debounce each time 
  // user types something in search filter field
  ctrl.searchChange = () => {
    if (ctrl.hasActiveEventRead) {
      ctrl.events = [];
      ctrl.loadEvents();
    }
  };

  ctrl.setSortType = column => {
    if (ctrl.loadBusy) return;
    ctrl.sortReverse = (ctrl.sortType === column) ? !ctrl.sortReverse : false;
    ctrl.sortType = column;
    ctrl.events = [];
    ctrl.loadEvents();
  };

  const sortEvents = () => {
    switch(ctrl.sortType) {
      case "CAR": {
        arraySortService.sortArrayWithKey(ctrl.events, 'carNumber', ctrl.sortReverse);
        break;
      }
      case "PRIORITY": {
        const valueMap = {"Red": 0, "Yellow": 1, "White": 2, null: 3};
        arraySortService.sortArrayWithMappedValues(ctrl.events, 'priority', ctrl.sortReverse, valueMap);
        break;
      }
      case "EVENT_ID": {
        arraySortService.sortArrayWithKey(ctrl.events, 'eventId', ctrl.sortReverse);
        break;
      }
      case "EVENT_TYPE": {
        arraySortService.sortArrayWithKey(ctrl.events, 'status', ctrl.sortReverse);
        break;
      }
      case "ACTIVATED": {
        arraySortService.sortArrayWithKey(ctrl.events, 'activated', ctrl.sortReverse);
        break;
      }
      case "TITLE": {
        arraySortService.sortArrayWithKey(ctrl.events, 'title', ctrl.sortReverse);
        break;
      }
      default: {
        console.log("Invalid sort choice", ctrl.sortType);
        break;
      }
    }
  };

  const startPoll = () => {
    if (!ctrl.dataFetchPromise) {
      ctrl.lastLoad = DateTime.now();
      ctrl.dataFetchPromise = $interval(triggerFetchLoad, 10000);
    }
  };

  const triggerFetchLoad = () => {
    if (ctrl.lastLoad.diffNow('seconds').seconds < -9) {
      ctrl.loadEvents();
    }
  };

  ctrl.openEvent = eventItem => {
    const modalInstance = $uibModal.open({
      templateUrl: '/modules/modals/notification-module.html',
      controller: 'notificationModalController',
      windowClass: 'medium-size-modal',
      resolve: {
        notificationItem: function () {
          return eventItem;
        },
        consist: function () {
          return eventItem.displayableTrainId ? eventItem.displayableTrainId : eventItem.consist;
        },
        listType: function () {
          return 'active';
        }
      },
    });
    modalInstance.result.then(
      reload => {
        if (reload) {
          ctrl.loadEvents();
        }
      },
      () => { }
    );
  };

  // Fetch list of active events, returns data if no error.
  // fetchEvents :: (Object) -> [Object]
  ctrl.fetchEvents = async params => {
    try {
      return await EventsService.getActiveFleetList(params);
    } catch (e) {
      console.error(`Event fetch error: ${e}`);
      return e;
    }
  };

  // Fetch list of active events for a single train, returns data if no error.
  // fetchEventsSingle :: (Object) -> [Object]
  ctrl.fetchEventsSingle = async (params, consist) => {
    try {
      return await EventsService.getActiveFleetListSingle(params, consist);
    } catch (e) {
      console.error(`Event fetch error: ${e}`);
      return e;
    }
  };

  ctrl.loadEvents = async () => {
    const el = document.querySelector('#activeEventsListGridletContainer');
    if (ctrl.loadBusy || el.scrollTop > 50) return;
    ctrl.loadBusy = true;
    const defaultCount = ctrl.settings.fullscreen ? 100 : 25;
    const customCount = Math.min(ctrl.events.length, 200);
    let params = {
      count: Math.max(defaultCount, customCount),
      skip: 0,
      eventSortType: ctrl.sortType,
      sortReverse: ctrl.sortReverse
    };
    if (ctrl.searchTerm) {
      params.searchString = ctrl.searchTerm;
    }
    let data = null;

    if (ctrl.currentView === 'configuration') {
      const carArray = await CarService.carListForConsist({consist: ctrl.consist});
      params.cars = [...carArray];
      data = await ctrl.fetchEventsSingle(params, ctrl.consist);

    } else if (ctrl.currentView === 'carView') {
      params.cars = [ctrl.selectedCar];
      data = await ctrl.fetchEvents(params);

    } else {
      data = await ctrl.fetchEvents(params);
    }

    if (data && !angular.equals(ctrl.events, data)) {
      ctrl.events = [...data];
    }
    adjustContentSize(ctrl.area, ctrl.contentAreaId);
    ctrl.loadBusy = false;
  };

  // TODO: figure out the difference. Only count parameter?
  ctrl.loadEventsPage = async () => {
    ctrl.currentScrollPos = document.querySelector('#activeEventsListGridletContainer').scrollTop;
    if (ctrl.loadBusy || ctrl.oldScrollPos === ctrl.currentScrollPos) return;
    ctrl.loadBusy = true;
    const params = {
      count: ctrl.settings.fullscreen ? 100 : 25,
      skip: ctrl.events.length || 0,
      eventSortType: ctrl.sortType,
      sortReverse: ctrl.sortReverse,
    };
    if (ctrl.searchTerm) {
      params.searchString = ctrl.searchTerm;
    }
    let data = null;

    if (ctrl.currentView === 'configuration') {
      const carArray = await CarService.carListForConsist({consist: ctrl.consist});
      params.cars = [...carArray];
      data = await ctrl.fetchEventsSingle(params, ctrl.consist);

    } else if (ctrl.currentView === 'carView') {
      params.cars = [ctrl.selectedCar];
      data = await ctrl.fetchEvents(params);

    } else {
      data = await ctrl.fetchEvents(params);
    }

    addEvents(data);
    adjustContentSize(ctrl.area, ctrl.contentAreaId);
    ctrl.loadBusy = false;
    ctrl.oldScrollPos = angular.copy(ctrl.currentScrollPos);
  };

  ctrl.exportTo = async (fileType) => {
    let criteria = {};
    criteria.skip = 0;
    criteria.count = 50000;
    criteria.localTimezone = DateTime.local().zoneName;
    criteria.sortReverse = ctrl.sortReverse;
    if (ctrl.sortType) {
      criteria.eventSortType = ctrl.sortType;
    } 
    if (ctrl.searchTerm) {
      criteria.searchString = ctrl.searchTerm;
    }

    if (ctrl.currentView === 'configuration' || ctrl.currentView === 'carView') {
      let carArray;
      if (ctrl.currentView === 'configuration') {
        carArray = await CarService.carListForConsist({consist: ctrl.consist});
      } else if (ctrl.currentView === 'carView' && ctrl.selectedCar) {
        carArray = [];
        carArray.push(ctrl.selectedCar);
      }
      criteria.cars = '';
      carArray.forEach((el, index) => {
        if (index === carArray.length - 1) {
          criteria.cars += carArray[index];
        } else {
          criteria.cars += `${carArray[index]},`;
        }
      });
    }
    ctrl.fetching = true;
    if (fileType === 'excel') {
      await eventsExportService.exportToExcel(criteria, $translate.instant('export.latest-active-events'), 'event/latest/active');
    } else if (fileType === 'csv') {
      await eventsExportService.exportToCsv(criteria, $translate.instant('export.latest-active-events'), 'event/latest/active');
    }
    ctrl.fetching = false;
  };

  function isSameEvent(event1, event2) {
    return event1.id === event2.id &&
        event1.consist === event2.consist &&
        event1.eventId === event2.eventId &&
        event1.carNumber === event2.carNumber &&
        event1.activated === event2.activated &&
        event1.title === event2.title &&
        event1.action === event2.action &&
        event1.priority === event2.priority &&
        event1.qualifier === event2.qualifier;
  }

  function addEvents(data) {
    data.forEach(item => {
      if (!ctrl.events.find(event => isSameEvent(event, item))) {
        ctrl.events.push(item);
      }
    });
    sortEvents();
  }

  ctrl.eventColor = event => {
      return event.priority;
  };
}

angular
  .module('gridlets.module')
  .controller('ActiveEventsListController', ActiveEventsListController);